import { createContext, FC, useState } from 'react'
import { EventId } from 'domain/models/ValueObject/EntityIds'

interface UserActionsContext {
  eventId: EventId | null
  setEventId: (eventId: EventId | null) => void
}

export const UserActionsContext = createContext<UserActionsContext>({
  setEventId: () => {},
  eventId: null
})

export const UserActionsProvider: FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [eventId, setEventId] = useState<EventId | null>(null)

  return (
    <UserActionsContext.Provider
      value={{
        setEventId,
        eventId
      }}
    >
      {children}
    </UserActionsContext.Provider>
  )
}
